import type { components } from "@/shared/api";

type InAppBrowser = components["schemas"]["InAppBrowser"];

// Метки встроенных браузеров приложений в строке браузера. Такие браузеры обычно не передают
// сайт-источник, и без метки заход из TikTok выглядит прямым.
const MARKERS: [InAppBrowser, RegExp][] = [
  ["tiktok", /BytedanceWebview|musical_ly|TikTok|trill_/i],
  ["instagram", /Instagram/i],
  ["facebook", /FBAN|FBAV|FB_IAB|FBIOS/i],
  ["telegram", /Telegram/i],
  ["vk", /VKAndroidApp|VKClient|com\.vkontakte/i],
  ["snapchat", /Snapchat/i],
  ["discord", /Discord/i],
];

// Приложение, во встроенном браузере которого открыт сайт; обычный браузер — `null`.
export const inAppBrowser = (userAgent: string): InAppBrowser | null =>
  MARKERS.find(([, marker]) => marker.test(userAgent))?.[0] ?? null;
